let scrollPosition = 0;
function scrollLock(){
  scrollPosition = window.pageYOffset;
  document.body.style.top = `-${scrollPosition}px`;
}

function scrollUnlock(){
  document.body.style.top = '';
  window.scrollTo(0, scrollPosition);
}

document.addEventListener('mousedown', function(e) {
  if (e.target.closest('.main_product_card_popup')) {
    document.body.classList.add('stopSearchCloseJS');
  }
});

document.addEventListener('mouseup', function(e) {
  setTimeout(() => {
    document.body.classList.remove('stopSearchCloseJS');
  }, 50);
});

document.addEventListener('touchstart', function(e) {
  if (e.target.closest('.main_product_card_popup')) {
    document.body.classList.add('stopSearchCloseJS');
  }
}, { passive: true });

document.addEventListener('touchend', function(e) {
  setTimeout(() => {
    document.body.classList.remove('stopSearchCloseJS');
  }, 50);
}, { passive: true });

document.addEventListener("click", async function(e) {
  if(e.target.closest('custom-qty-atc')){
    return;
  }
  var clickTarget = e.target.closest(".new_product_card") || e.target.closest(".recent_search_link");
  
  if(clickTarget && window.innerWidth < 750){
    e.preventDefault();
    e.stopPropagation();
    
    if (clickTarget.closest("cart-drawer")) {
      var data_handle = clickTarget.getAttribute("data_handle"),
          popupHTML = `
          <div class="popup_main main_cart_product_popup hidden" data_handle="${data_handle}">
            <div class="popup">
              ${closePopupHtml}
              <div class="single_pro_data"></div>
            </div>
          </div>
        `;

      document.body.insertAdjacentHTML("beforeend", popupHTML);

      var slide = document.querySelector(".main_cart_product_popup:last-child");
      loadSlideContent(slide);

      slide.classList.remove("hidden");

      return;
    }

    var parent = clickTarget.parentElement,
        allCards = parent.querySelectorAll(".new_product_card"),
        slidesHTML = "",
        currentIndex = [...allCards].indexOf(clickTarget);

    allCards.forEach(function(card) {
      var data_handle = card.getAttribute("data_handle");
          slidesHTML += `
            <div class="custom_slide" data_handle="${data_handle}">
              ${closePopupHtml}
              <div class="single_pro_data mainContent"></div>
            </div>`;
    });
    var popupHTML = `
      <div class="popup_main hidden main_product_card_popup">
        <div class="popup">
          <div class="popup_data popup_data_JS">
            <div class="custom_product_slider">
              ${slidesHTML}
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML("beforeend", popupHTML);

    scrollLock();

    var allPopups = document.querySelectorAll('.main_product_card_popup'),
        currentPopup = allPopups[allPopups.length - 1];

    if(currentPopup.classList.contains('hidden')){
      currentPopup.classList.remove('hidden');
    }
    
    var sliderWrapper = currentPopup.querySelector('.custom_product_slider'),
        slides = currentPopup.querySelectorAll('.custom_slide');
    
    if (slides[currentIndex]) {
      setTimeout(() => {
        slides[currentIndex].scrollIntoView({ behavior: 'instant', inline: 'center' });
      }, 10);
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (entry.target.nextElementSibling) {
            loadSlideContent(entry.target.nextElementSibling);
          }
          if (entry.target.previousElementSibling) {
            loadSlideContent(entry.target.previousElementSibling);
          }
          
          loadSlideContent(entry.target);

          slides.forEach(s => s.classList.remove('active_slide'));
          entry.target.classList.add('active_slide');
          
          var handle = entry.target.getAttribute("data_handle");
          if(handle){
            window.history.replaceState({}, '', `/products/${handle}`);
          }
        }
      });
    }, {
      root: sliderWrapper,
      threshold: 0.5
    });

    slides.forEach(slide => observer.observe(slide));
  }

  if (e.target.closest('.close_popup_JS') && e.target.closest('.main_product_card_popup')) {
    e.preventDefault();
    e.stopPropagation();
    
    var popupMain = e.target.closest('.main_product_card_popup');
    var sliderWrapper = popupMain.querySelector('.custom_product_slider');
    var slide = sliderWrapper.querySelector('.active_slide');
    
    if (sliderWrapper && sliderWrapper.classList.contains('is_expanded')) {
      sliderWrapper.style.transition = "all 0.35s cubic-bezier(0.25, 1, 0.5, 1)";
      if (slide) slide.style.transition = "all 0.35s cubic-bezier(0.25, 1, 0.5, 1)";
      
      popupMain.style.setProperty('--scroll-progress', 0);
      sliderWrapper.classList.remove('is_expanded');
    
      setTimeout(() => {
        sliderWrapper.style.transition = "";
        if (slide) {
          slide.style.transition = "";
          slide.scrollTop = 0;
        }
      }, 350);
      
      window.history.replaceState({}, '', originalURL);
    }
    else {
      popupMain.remove();
      window.history.replaceState({}, '', originalURL);
      scrollUnlock();
    }
  }

  if(e.target.classList.contains('custom_product_slider')){
    e.preventDefault();
    e.stopPropagation();
    e.target.closest('.main_product_card_popup').remove();
    window.history.replaceState({}, '', originalURL);
    scrollUnlock();
  }
  
  var clickTarget = e.target.closest(".cart_drawer_single_item");
  if (clickTarget && window.innerWidth < 750) {
    e.preventDefault();

    if(e.target.closest('.cart-item__quantity')){
      return;
    }
    if(e.target.closest('.add_item_JS')){
      return;
    }

    var data_handle = clickTarget.getAttribute("data_handle"),
        popupHTML = `
        <div class="popup_main main_cart_product_popup hidden" data_handle="${data_handle}">
          <div class="popup">
            ${closePopupHtml}
            <div class="single_pro_data"></div>
          </div>
        </div>
      `;
    document.body.insertAdjacentHTML("beforeend", popupHTML);

    var slide = document.querySelector(".main_cart_product_popup");
    loadSlideContent(slide);
    
    if(slide.classList.contains('hidden')){
      slide.classList.remove('hidden');
    }
  }
  
  if(e.target.closest('.close_popup_JS') && e.target.closest('.main_cart_product_popup')){
    e.preventDefault();
    e.stopPropagation();
    e.target.closest('.main_cart_product_popup').remove();
  }
});

async function loadSlideContent(slide) {
  if (!slide) return;
  if (slide.querySelector('.shopify-section')) return;

  var handle = slide.getAttribute("data_handle");
  
  try {
    var response = await fetch(`/products/${handle}`),
        htmlText = await response.text(),
        parser = new DOMParser(),
        newHtml = parser.parseFromString(htmlText, "text/html"),
        mainContent = newHtml.querySelector("main#MainContent");

    if (mainContent) {    
        slide.querySelector(".single_pro_data").innerHTML = mainContent.innerHTML;
        
        var popupData = slide.querySelector(".single_pro_data"),
            scripts = popupData.querySelectorAll("script");

        scripts.forEach(oldScript => {
          const newScript = document.createElement("script");

          Array.from(oldScript.attributes).forEach(attr => {
            newScript.setAttribute(attr.name, attr.value);
          });

          if (oldScript.src) {
            newScript.src = oldScript.src;
            newScript.async = false;
          } else {
            newScript.textContent = oldScript.textContent;
          }

          oldScript.parentNode.replaceChild(newScript, oldScript);
        });

        if(typeof sectionJavascriptRun === 'function'){
            sectionJavascriptRun();
        }
        
        setTimeout(() => {
          if (typeof RecentlyViewedProductHandleList === 'function') {
            RecentlyViewedProductHandleList(handle);
          }
        }, 999);
        mobileOpenDetails();
    } else {
      slide.querySelector(".single_pro_data").innerHTML = `<div class="error">Product Content Not Found</div>`;
    }
  } catch (error) {
    console.log(error);
    slide.querySelector(".single_pro_data").innerHTML = `<div class="error">Failed To Load Product</div>`;
  }
}

function mobileOpenDetails(){
  if(document.querySelector('.dropdown_up_dawn') && window.innerWidth < 750){
    document.querySelectorAll('.dropdown_up_dawn').forEach(function(singleDeatils){
      singleDeatils.setAttribute("open", true);
    });
  }
}

mobileOpenDetails();

var popupTouchStartY = 0,
    popupTouchStartX = 0,
    isTransitioning = false,
    isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

document.addEventListener("touchstart", function(e) {
  if (e.target.closest('.main_product_card_popup')) {
    popupTouchStartY = e.touches[0].clientY;
    popupTouchStartX = e.touches[0].clientX;
  }
}, { passive: true });

document.addEventListener("touchmove", function(e) {
  if (isTransitioning) return;
  var slide = e.target.closest('.active_slide');
  if (!slide) return;

  var popupMain = e.target.closest('.main_product_card_popup');
  if (!popupMain) return;

  var sliderWrapper = popupMain.querySelector('.custom_product_slider');
  if (!sliderWrapper) return;

  var isExpanded = sliderWrapper.classList.contains('is_expanded'),
      touchCurrentY = e.touches[0].clientY,
      touchDiff = touchCurrentY - popupTouchStartY,
      touchCurrentX = e.touches[0].clientX,
      touchDiffX = Math.abs(touchCurrentX - popupTouchStartX),
      touchDiffY = Math.abs(touchCurrentY - popupTouchStartY);
      
  if (touchDiffX > touchDiffY) {
      return;
  }

  var swipeThreshold = 8;
      
  if (!isExpanded && touchDiff < -swipeThreshold) {
    isTransitioning = true;
     window.requestAnimationFrame(function() {
         sliderWrapper.style.transition = "all 0.3s ease-out";
         slide.style.transition = "all 0.3s ease-out";
         popupMain.style.setProperty('--scroll-progress', 1);
         sliderWrapper.classList.add('is_expanded');
         
         if (isIOS) {
             slide.style.overflowY = 'auto';
             slide.style.webkitOverflowScrolling = 'touch';
             void slide.offsetHeight; 
             setTimeout(() => {
                 if (slide.scrollTop === 0) slide.scrollTop = 2; 
             }, 20);
         }

         setTimeout(() => {
             sliderWrapper.style.transition = "";
             slide.style.transition = "";
             if (isIOS) {
                 slide.style.overflowY = ''; 
             }
             isTransitioning = false;
         }, 300);
     });
  }
  
  if (isExpanded && slide.scrollTop <= 0 && touchDiff > swipeThreshold) {
     isTransitioning = true;
     window.requestAnimationFrame(function() {
         sliderWrapper.style.transition = "all 0.3s ease-out";
         slide.style.transition = "all 0.3s ease-out";
         popupMain.style.setProperty('--scroll-progress', 0);
         sliderWrapper.classList.remove('is_expanded');
         
         setTimeout(() => {
             sliderWrapper.style.transition = "";
             slide.style.transition = "";
             isTransitioning = false;
         }, 300);
     });
  }
}, { passive: true });

document.addEventListener("touchend", function(e) {
  var popupMain = e.target.closest('.main_product_card_popup');
  if (!popupMain) return;

  var sliderWrapper = popupMain.querySelector('.custom_product_slider');
  if (!sliderWrapper) return;

  var slide = sliderWrapper.querySelector('.active_slide');
  if (!slide) return;

  var currentProgress = parseFloat(popupMain.style.getPropertyValue('--scroll-progress')) || 0;

  if (currentProgress > 0 && currentProgress < 1) {      
      sliderWrapper.style.transition = "all 0.3s ease-out";
      slide.style.transition = "all 0.3s ease-out";
      if (currentProgress > 0.25) {          
          popupMain.style.setProperty('--scroll-progress', 1);
          sliderWrapper.classList.add('is_expanded');
      } else {          
          popupMain.style.setProperty('--scroll-progress', 0);
          sliderWrapper.classList.remove('is_expanded');
      }
      
      setTimeout(() => {
          sliderWrapper.style.transition = "";
          slide.style.transition = "";
      }, 300);
  }
});

document.addEventListener('wheel', function(e) {
  var slide = e.target.closest('.active_slide');
  if (!slide) return;
  var popupMain = e.target.closest('.main_product_card_popup');
  if (!popupMain) return;
  var sliderWrapper = popupMain.querySelector('.custom_product_slider');
  if (!sliderWrapper) return;
  var isExpanded = sliderWrapper.classList.contains('is_expanded');

  if (!isExpanded && e.deltaY > 0) {
      sliderWrapper.style.transition = "all 0.3s ease-out";
      slide.style.transition = "all 0.3s ease-out";
      popupMain.style.setProperty('--scroll-progress', 1);
      sliderWrapper.classList.add('is_expanded');
      setTimeout(() => { sliderWrapper.style.transition = ""; slide.style.transition = ""; }, 300);
  } else if (isExpanded && slide.scrollTop <= 0 && e.deltaY < 0) {
      sliderWrapper.style.transition = "all 0.3s ease-out";
      slide.style.transition = "all 0.3s ease-out";
      popupMain.style.setProperty('--scroll-progress', 0);
      sliderWrapper.classList.remove('is_expanded');
      setTimeout(() => { sliderWrapper.style.transition = ""; slide.style.transition = ""; }, 300);
  }
}, { passive: true });